export default "__VITE_ASSET__CJMcBqXQ__"